import { TProject, TProjectsApiResponse } from '../../types/config';
import { processProject } from '../../hardcode/utils';
import { fetchData } from './fetch-data';

export async function getProjectsByClients(
  project: TProject,
  apiUrl: string,
  awsUrl: string,
): Promise<TProject[]> {
  if (!project?.id) {
    console.warn('getProjects called without valid project ID');
    return [];
  }

  try {
    const clientIds = project?.clients?.map((client) => client.id) || [];

    if (!clientIds.length) { // we don't need random return at this moment
      return [];
    }

    const projectsRes: TProjectsApiResponse | null = await fetchData(
      apiUrl,
      'api/public/projects',
      'POST',
      {
        options: {
          clientIds,
        },
      },
    );

    if (!projectsRes) {
      throw new Error('Failed to fetch projects data');
    }

    return (
      projectsRes.data.projects
        ?.map((p) => processProject(p, awsUrl) as TProject)
        .filter((p) => p.id !== project.id) || []
    );
  } catch (error) {
    console.error('Error fetching projects:', error);
    return [];
  }
}
